<template>
  <div class="users">
    <form method="POST" autocomplete="on">
      <div class="form-group">
        <label for="email">Email</label>
        <input
          type="email"
          class="form-control"
          placeholder="email"
          v-model.trim="email"
          autocomplete="email"
          required
        />
      </div>
      <div class="form-group">
        <label for="password">password</label>
        <input
          type="password"
          class="form-control"
          placeholder="password"
          v-model.trim="password"
          required
        />
      </div>
      <button
        type="submit"
        id="save"
        class="btn btn-primary btn-lg btn-block mt-4"
        @click.prevent="save"
      >
        Login
      </button>
      <div class="my-2">
        <div
          class="alert alert-succes"
          role="alert"
          v-if="this.$store.state.error"
        >
          <strong>Account</strong> {{ this.$store.state.error }}
        </div>
      </div>
    </form>
  </div>
</template>

<script>
// import axios from "axios";
// import { auth } from "@/firebase";

export default {
  data() {
    return {
      email: null,
      password: null,
      error: null,
    };
  },
  methods: {
    save() {
      this.$store.dispatch("login", {
        email: this.email,
        password: this.password,
      });

      this.email = "";
      this.password = "";
    },
  },
};
</script>
